<mat-form-field>
  <mat-label>{{ label }}</mat-label>
  <ng-content></ng-content>
  <mat-error *ngFor="let error of prepareErrors(control?.ngControl?.errors)">{{ error }}</mat-error>
</mat-form-field>
